// import React from 'react';
// import './HeroSection.css';
// import { Link } from 'react-router-dom';

// const HeroSection = () => {
//   return (
//     <div className="hero">
//       <div className="hero-wrapper">
//         <h1>Welcome to Igboeze North LGA</h1>
//         <p>Empowering communities, enhancing development, and promoting good governance.</p>
//         <Link to="/about" className="hero-btn">Learn More</Link>
//       </div>
//     </div>
//   );
// };

// export default HeroSection;

import React, { useEffect, useState } from 'react';
import './HeroSection.css';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

const slides = [
  {
    image: require('../../assets/images/peter-mbah-1.JPG'),
    heading: 'Welcome to Igbo-Eze North LGA',
    subText: 'Empowering communities, enhancing development, and promoting good governance.',
  },
  {
    image: require('../../assets/images/igboeze-chairman.JPG'),
    heading: 'Inclusive Governance',
    subText: 'Empowering communities by bringing transparent and responsive governance closer to the grassroots level.',
  },
  {
    image: require('../../assets/images/peter-mbah-2.JPG'),
    heading: 'Tomorrow is Here',
    subText: 'Governor Peter Mbah is driving innovation and transformation across Enugu State.',
  },
  {
    image: require('../../assets/images/peter-mbah-3.JPG'),
    heading: 'Leadership with Vision',
    subText: 'Building modern infrastructure and empowering the youth.',
  },
  {
  image: require('../../assets/images/igboeze-north-building.JPG'),
  heading: 'Seat of Local Authority',
  subText: 'A symbol of leadership and public service, the local government headquarters stands as a hub for inclusive governance and community-driven development.',
},
];

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % slides.length);
  const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);

  const { image, heading, subText } = slides[currentSlide];

  return (
    <div className="hero" style={{ backgroundImage: `url(${image})` }}>
      <div className="hero-overlay" />
      <div className="hero-wrapper">
        <h1>{heading}</h1>
        <p>{subText}</p>
        <Link to="/about" className="hero-btn">Learn More</Link>
        <div className="hero-controls">
          <FaArrowLeft className="arrow-icon" onClick={prevSlide} />
          <FaArrowRight className="arrow-icon" onClick={nextSlide} />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;